import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ShopInformationFileApi } from 'api';
import type { ShopInformationFile } from 'api/methods/ShopInformationFileApi';

/**
 * [ShopInformationFile] Query key 생성
 * --
 */
export const shopInformationFileQueryKeys = createQueryKeys(
  'shopInformationFile',
  {
    getShopInformationFile: (
      idx: number,
      params?: { [key: string]: string | number }
    ) => [idx, params],
    getShopInformationFiles: (params?: { [key: string]: string | number }) => [
      params,
    ],
  }
);

/**
 * [ShopInformationFile] 쇼/브/매/지 파일 전체 조회
 * --
 */
export const useGetShopInformationFiles = (
  params?: {
    [key: string]: string | number;
  },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey:
      shopInformationFileQueryKeys.getShopInformationFiles(params).queryKey,
    queryFn: () => ShopInformationFileApi.getShopInformationFiles(params),
    ...options,
  });
  return data;
};

/**
 * [ShopInformationFile] 쇼/브/매/지 파일 상세 조회
 * --
 */
export const useGetShopInformationFile = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: shopInformationFileQueryKeys.getShopInformationFile(idx, params)
      .queryKey,
    queryFn: () => ShopInformationFileApi.getShopInformationFile(idx, params),
  });

  return data;
};

/**
 * [ShopInformationFile] 쇼/브/매/지 파일 생성
 * --
 */
export const useCreateShopInformationFile = () => {
  const { mutateAsync: createShopInformationFile, ...result } = useMutation({
    mutationFn: (variables: ShopInformationFile) =>
      ShopInformationFileApi.createShopInformationFile(variables),
  });

  return { createShopInformationFile, ...result };
};

/**
 * [ShopInformationFile] 쇼/브/매/지 파일 수정
 * --
 */
export const useUpdateShopInformationFile = (body: ShopInformationFile) => {
  const { mutateAsync: updateShopInformationFile, ...result } = useMutation({
    mutationFn: (variables: ShopInformationFile) =>
      ShopInformationFileApi.updateShopInformationFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateShopInformationFile, ...result };
};

/**
 * [ShopInformationFile] 쇼/브/매/지 파일 삭제
 * --
 */
export const useDeleteShopInformationFile = (idx: number) => {
  const { mutateAsync: deleteShopInformationFile, ...result } = useMutation({
    mutationFn: (variables: number) =>
      ShopInformationFileApi.deleteShopInformationFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteShopInformationFile, ...result };
};
